export default __webpack_public_path__ + "static/media/yo4.ebd6bef8.png";